<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { logout } from '@/modules/authentication/authenticationService'
import { useAuth } from '@/modules/authentication/authStore'

const store = useAuth()
const { user } = storeToRefs(store)

const menu = ref()
const items = ref([
  {
    title: 'Профиль',
    prependIcon: 'mdi-account',
    onClick: () => openProfile(),
  },
  {
    title: 'Выход',
    prependIcon: 'mdi-logout',
    onClick: () => logout(),
  },
])

const userName = computed(() => user.value?.fullName ?? '')

function openProfile() {
  console.log('openProfile')
}
</script>

<template>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template #activator="{ props }">
      <v-btn
        color="white"
        variant="text"
        v-bind="props"
      >
        <v-icon icon="mdi-account" size="26" class="mr-2" />
        {{ userName }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :title="item.title"
        :prepend-icon="item.prependIcon"
        min-height="40"
        @click="item.onClick"
      />
    </v-list>
  </v-menu>
</template>
